import { defineStore } from "pinia";

export const useSectionStore = defineStore("SectionStore", {
  state: () => {
    return {
      panel: [0], //index to the test panel that is currently expanded

      // The v-expansion-panel is ordered based on which test was added and the DOM has
      // a rigid order we are keeping both of these orders to index and scroll to the right nextPanel indexes.
      testOrderDom: [],
      AddedOrderofPanels: [],
      isPrenatal: null,
      patientDetails: {},
      deligateBillingAddress: null,
      victorianPatient: false,
      freeTestForVictorian: false,
      pregnant: null,
      showTests: {
        fragilex: {
          name: "fragilex",
          show: false,
          testName: "Fragile X syndrome",
          mediumTest: false,
          category: ["freqReq", "cytogenetics", "medicare"],
          hasPregnant: true,
        },
        prader_willi: {
          name: "prader_willi",
          show: false,
          testName: "Prader willi / Angelman syndrome",
          mediumTest: false,
          category: ["freqReq", "cytogenetics", "medicare"],
          hasPregnant: true,
        },
        connexin_dfnb1: {
          name: "connexin_dfnb1",
          show: false,
          testName: "Connexin / DFNB1",
          mediumTest: false,
          category: ["deafness"],
          hasPregnant: false,
        },
        deafness_mlpa: {
          name: "deafness_mlpa",
          show: false,
          testName: "Deafness MLPA",
          mediumTest: true,
          category: ["deafness"],
          hasPregnant: false,
        },
        PHOX2B: {
          name: "PHOX2B",
          show: false,
          testName: "PHOX2B poly-alanine expansion testing",
          mediumTest: true,
          category: ["neurogen"],
          hasPregnant: false,
        },
        microarray: {
          name: "microarray",
          show: false,
          testName: "Microarray",
          mediumTest: false,
          category: ["freqReq", "cytogenetics", "medicare"],
          hasPregnant: true,
        },
        mito_diagnostic: {
          name: "mito_diagnostic",
          show: false,
          testName: "Mitochondrial disease - diagnostic WGS testing",
          mediumTest: false,
          category: ["freqReq", "mito", "genomics", "medicare"],
          hasPregnant: false,
        },
        variant_detection: {
          name: "variant_detection",
          show: false,
          testName: "Familial variant detection - cascade/predictive",
          mediumTest: false,
          category: ["freqReq", "mito", "kidney", "medicare"],
          hasPregnant: false,
        },
        clinical_exome: {
          name: "clinical_exome",
          show: false,
          testName: "Exome sequencing",
          mediumTest: false,
          category: ["genomics", "freqReq"],
          hasPregnant: false,
        },
        childhood_syndromes: {
          name: "childhood_syndromes",
          show: false,
          testName: "Childhood syndrome - diagnostic exome or WGS",
          mediumTest: false,
          category: ["genomics", "medicare", "freqReq"],
          hasPregnant: false,
        },
        whole_genome_sequencing: {
          name: "whole_genome_sequencing",
          show: false,
          testName: "Whole genome sequencing",
          mediumTest: false,
          category: ["genomics", "freqReq"],
          hasPregnant: false,
        },
        alport: {
          name: "alport",
          show: false,
          testName: "Alport syndrome - diagnostic exome",
          mediumTest: false,
          category: ["genomics", "kidney", "medicare"],
          hasPregnant: false,
        },
        renal_non_cystic: {
          name: "renal_non_cystic",
          show: false,
          testName:
            "Kidney disease (non-cystic, non-Alport) - diagnostic exome",
          mediumTest: false,
          category: ["genomics", "kidney", "medicare"],
          hasPregnant: false,
        },
        renal_cystic: {
          name: "renal_cystic",
          show: false,
          testName: "Cystic kidney disease - diagnostic exome",
          mediumTest: false,
          category: ["genomics", "kidney", "medicare"],
          hasPregnant: false,
        },
        SCA15: {
          name: "SCA15",
          show: false,
          testName: "Spinocerebellar ataxia 15",
          mediumTest: false,
          category: ["neurogen", "cytogenetics"],
          hasPregnant: false,
        },
        snhl: {
          name: "snhl",
          show: false,
          testName: "Exome focused + deafness MLPA bundle",
          mediumTest: false,
          category: ["genomics", "deafness"],
          hasPregnant: false,
        },
        mito: {
          name: "mito",
          show: false,
          testName: "Mitochondrial genome (mtDNA) sequencing",
          mediumTest: false,
          category: ["mito"],
          hasPregnant: false,
        },
        mito_cascade: {
          name: "mito_cascade",
          show: false,
          testName: "Mitochondrial (mtDNA) familial variant testing",
          mediumTest: false,
          category: ["mito"],
          hasPregnant: false,
        },
        prenatal_rapid_genomic_trio: {
          name: "prenatal_rapid_genomic_trio",
          show: false,
          testName: "Prenatal rapid genomic trio",
          category: ["prenatal"],
          hasPregnant: false,
        },
        prenatal_targeted_exome: {
          name: "prenatal_targeted_exome",
          show: false,
          testName: "Prenatal targeted exome (familial variant testing)",
          category: ["prenatal"],
          hasPregnant: false,
        },
        prenatal_targeted_genome: {
          name: "prenatal_targeted_genome",
          show: false,
          testName: "Prenatal targeted WGS (familial variant testing)",
          category: ["prenatal"],
          hasPregnant: false,
        },
      },
    };
  },
  getters: {
    hasPregnantTests(state) {
      return Object.values(state.showTests).some(
        (t) => t.show && t.hasPregnant,
      );
    },
    patientPregnant(state) {
      return this.hasPregnantTests ? state.pregnant : null;
    },
  },
  actions: {
    nextPanel(nextPanel) {
      const index = this.AddedOrderofPanels.indexOf(nextPanel);
      this.panel = [index];
    },
    testCategoryChosen() {
      return this.isPrenatal !== null;
    },
    // change state stored array to represent all currently chosen panels. for example if you want all three panels open, panel v-model="[0,1,2]"
    openAllPanels() {
      this.panel = [];
      this.testOrderDom.map((value) => {
        this.panel.push(this.testOrderDom.indexOf(value));
      });
    },
    removeAllTests() {
      this.testOrderDom = [];
      this.AddedOrderofPanels = [];
      this.deligateBillingAddress = null;
      this.victorianPatient = false;
      this.freeTestForVictorian = false;
      Object.keys(this.showTests).map((test) => {
        this.showTests[test].show = false;
      });
    },
    hasTests() {
      let shown = false;
      Object.keys(this.showTests).map((test) => {
        if (this.showTests[test].show === true) {
          shown = true;
        }
      });
      return shown;
    },
  },
});

export const useCompletedDetails = defineStore("CompletedDetails", {
  state: () => {
    return {
      prenatal_targeted_exome: [],
      prenatal_targeted_exome_family: [],
      prenatal_rapid_genomic_trio: [],
      prenatal_rapid_genomic_trio_family: [],
      prenatal_targeted_genome: [],
      prenatal_targeted_genome_family: [],
    };
  },
});
